export default "__VITE_ASSET__7e08d76c__"